import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useIntl } from 'react-intl-next';
import Avatar from '@atlaskit/avatar';
import { messages } from '../../../../../messages';
import { useAIAnswerContext } from '../../../../ai-answer-context';
import { onWhoPrimaryCoordinationPillClick, onWhoPrimaryCoordinationPillContextMenuClick } from '../../../../analytics';
import { NLPSearchResultContainerDataTypeContainerType } from '../../../../types';
import { AIWhoAnswerSectionHeader, AIWhoAnswerSectionResult, AIWhoAnswerSectionResultInfoHeader, AIWhoAnswerSectionResultInfoWrapper, AIWhoAnswerSectionResultMetadata, AIWhoAnswerSectionResultsWrapper, AIWhoAnswerSectionWrapper } from './styled';
var WHO_SECTION_MAX_ITEMS = 3;
export var AIAnswerWhoSection = function AIAnswerWhoSection(_ref) {
  var sectionId = _ref.sectionId,
    sectionHeader = _ref.sectionHeader,
    sectionResults = _ref.sectionResults,
    avatarAppearance = _ref.avatarAppearance;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent,
    onNavigate = _useAIAnswerContext.onNavigate;
  var getSectionResultMetadata = function getSectionResultMetadata(sectionResult) {
    if ('containerType' in sectionResult) {
      switch (sectionResult.containerType) {
        case NLPSearchResultContainerDataTypeContainerType.ConfluenceSpace:
          return 'Confluence';
        case NLPSearchResultContainerDataTypeContainerType.JiraProject:
          return 'Jira Software';
        default:
          return '';
      }
    }
    if ('title' in sectionResult) {
      return sectionResult.title || '';
    }
    if ('memberCount' in sectionResult) {
      return formatMessage(messages.ai_answer_who_question_team_section_member_count, {
        count: sectionResult.memberCount
      });
    }
    return '';
  };
  return sectionResults && sectionResults.length ? /*#__PURE__*/React.createElement(AIWhoAnswerSectionWrapper, null, /*#__PURE__*/React.createElement(AIWhoAnswerSectionHeader, null, formatMessage(sectionHeader)), /*#__PURE__*/React.createElement(AIWhoAnswerSectionResultsWrapper, null, sectionResults.slice(0, WHO_SECTION_MAX_ITEMS).map(function (sectionResult) {
    return /*#__PURE__*/React.createElement(AIWhoAnswerSectionResult, {
      key: sectionResult.name,
      href: sectionResult.url || undefined,
      onClick: function onClick(event) {
        onNavigate(event);
        fireAnalyticsEvent(onWhoPrimaryCoordinationPillClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
          resultSection: sectionId,
          resultTitle: sectionResult.name
        })));
      },
      onContextMenu: function onContextMenu() {
        fireAnalyticsEvent(onWhoPrimaryCoordinationPillContextMenuClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
          resultSection: sectionId,
          resultTitle: sectionResult.name
        })));
      }
    }, /*#__PURE__*/React.createElement(Avatar, {
      appearance: avatarAppearance,
      src: sectionResult.iconUrl || sectionResult.picture || sectionResult.avatarUrl || undefined,
      size: "medium"
    }), /*#__PURE__*/React.createElement(AIWhoAnswerSectionResultInfoWrapper, null, /*#__PURE__*/React.createElement(AIWhoAnswerSectionResultInfoHeader, null, sectionResult.name), /*#__PURE__*/React.createElement(AIWhoAnswerSectionResultMetadata, null, getSectionResultMetadata(sectionResult))));
  }))) : null;
};